import React from 'react';
import './OrientationGate.css';

/**
 * Blocks a game with a "rotate your device" overlay whenever a touch device is held in portrait orientation. Pure CSS -
 * re-evaluates automatically on orientation change, no JS/listeners needed. Used on the learners' play page (/play/<token>),
 * which has nothing else to navigate to, so unlike fun-activities' copy it offers no login links.
 */
function OrientationGate() {
  return (
    <div className="orientation-gate" role="alert">
      <div className="orientation-gate-icon">📱</div>
      <h2 className="orientation-gate-title">Rotate Your Device</h2>
      <p className="orientation-gate-message">
        These games are designed for landscape mode. Please rotate your device to continue playing.
      </p>
    </div>
  );
}

export default OrientationGate;
